import { red } from '@mui/material/colors';

const style = {
  redItem: {
    color: red[700],
  },
};

export default style;
